import { z } from "zod";

export const TRACIFY_AGENT_ID = "tracify-analytics" as const;
export const MEDIA_BUYING_AGENT_ID = "tracify-media-buying" as const;

export const chatAgentIdValues = [
  TRACIFY_AGENT_ID,
  MEDIA_BUYING_AGENT_ID,
] as const;

export const chatAgentIdSchema = z.enum(chatAgentIdValues);

export type ChatAgentId = z.infer<typeof chatAgentIdSchema>;
